import {Toast} from 'vant-green'
export function handlerDateToDay(timeStamp,format = 'YYYY-MM-DD'){
  if (timeStamp) {
      let week = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      let date = new Date(parseInt(timeStamp));
      let o = {
        "M+": date.getMonth() + 1,
        "D+": date.getDate(),
        "h+": date.getHours() % 12,
        "H+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S+": date.getMilliseconds(),
        "W+": week[date.getDay()],
      };

      if (/(Y+)/.test(format))
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (let k in o)
        if (new RegExp("(" + k + ")").test(format))
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return format;
    }
}
export function handlerDateToTime(timeStamp){
  return handlerDateToDay(timeStamp,'YYYY-MM-DD HH:mm:ss')
}
export function tableDateToDay(row,column,cellValue,index){
  return handlerDateToDay(cellValue)
}
export function addMonth(time,add = 1){
if(time){
  let date = new Date(time)
  let month = date.getMonth()+add
  date.setMonth(month%12)
  date.setFullYear(date.getFullYear()+month/12)
  return date.getTime()
}
return time
}

export function onExport(data,col,title = "列表"){
if(data){
  title += handlerDateToDay(new Date().getTime())
require.ensure([],()=>{
  const {export_json_to_excel } =require('../views/public/Export2Excel')
  let tHeader = col.map(item=>item[0])
  let tData = data.map(d=>col.map(item=>getPenetrateValue(d,item[1])))
  export_json_to_excel(tHeader,tData,title)
})
}
}
export function getPenetrateValue(data,param){
if(data&&param){
  if(param.indexOf('.')==-1){
    return data[param]
  }
  let v = data
  let ks = param.split(".")
  ks.forEach(item=>{
    v = v[item]
  })
  return v
}
return ""
}

/**
* @param {Function} func
* @param {number} wait
* @param {boolean} immediate
* @return {*}
*/
export function debounce(func, wait, immediate) {
let timeout, args, context, timestamp, result

const later = function() {
  // 据上一次触发时间间隔
  const last = +new Date() - timestamp

  // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
  if (last < wait && last > 0) {
    timeout = setTimeout(later, wait - last)
  } else {
    timeout = null
    // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
    if (!immediate) {
      result = func.apply(context, args)
      if (!timeout) context = args = null
    }
  }
}

return function(...args) {
  context = this
  timestamp = +new Date()
  const callNow = immediate && !timeout
  // 如果延时不存在，重新设定延时
  if (!timeout) timeout = setTimeout(later, wait)
  if (callNow) {
    result = func.apply(context, args)
    context = args = null
  }

  return result
}
}


export function saveLogToLocal(...saveLogs){
  try{
    saveLogs.unshift({logCreated:handlerDateToTime(new Date().getTime())})
    let logsStr = localStorage.getItem('ts_logs');
    let logs = []
    if(logsStr&&logsStr!='null'&&logsStr!='undefined'){
      logs = JSON.parse(logsStr)
    }
    logs.unshift(saveLogs)
    logs = logs.slice(0,10000)
    localStorage.setItem('ts_logs',JSON.stringify(logs))
  }catch(err){
    // console.log(err)
  }
}
export function getLocalLog(){
  return localStorage.getItem('ts_logs');
}
export function clearLocalLog(){
  localStorage.setItem('ts_logs',undefined)
}

export function requiredFailPosition(elementId){
  //提示选择
  //两秒上滑到指定顶部
  let element = document.getElementById(elementId);
  let height = element.scrollTop;
  let step = Math.floor(height / 50);
  let timer = setInterval(()=> {
      if(element.scrollTop <= 0){
          element.scrollTop = 0
          clearInterval(timer);
      } else {
          element.scrollTop -= step;
      }
  },10)
  Toast.fail('请填写数据！');
}